/**
* Created by ctsi-biyi-generator
*/
export default {
'zh-CN': {
'tqtActivity.id.label': '',
'tqtActivity.id.holder': '请输入',
'tqtActivity.id.max': '最多11个字符',
'tqtActivity.id.required': '必填',
'tqtActivity.searchId.holder': '搜索',
'tqtActivity.adminId.label': '管理员id',
'tqtActivity.adminId.holder': '请输入管理员id',
'tqtActivity.adminId.max': '管理员id最多11个字符',
'tqtActivity.adminId.required': '管理员id必填',
'tqtActivity.searchAdminId.holder': '搜索管理员id',
'tqtActivity.theme.label': '主题',
'tqtActivity.theme.holder': '请输入主题',
'tqtActivity.theme.max': '主题最多58个字符',
'tqtActivity.theme.required': '主题必填',
'tqtActivity.searchTheme.holder': '搜索主题',
'tqtActivity.picPath.label': '图片路径',
'tqtActivity.picPath.holder': '请输入图片路径',
'tqtActivity.picPath.max': '图片路径最多255个字符',
'tqtActivity.picPath.required': '图片路径必填',
'tqtActivity.searchPicPath.holder': '搜索图片路径',
'tqtActivity.address.label': '地点',
'tqtActivity.address.holder': '请输入地点',
'tqtActivity.address.max': '地点最多58个字符',
'tqtActivity.address.required': '地点必填',
'tqtActivity.searchAddress.holder': '搜索地点',
'tqtActivity.organization.label': '组织机构',
'tqtActivity.organization.holder': '请输入组织机构',
'tqtActivity.organization.max': '组织机构最多54个字符',
'tqtActivity.organization.required': '组织机构必填',
'tqtActivity.searchOrganization.holder': '搜索组织机构',
'tqtActivity.applyEndTime.label': '(报名结束时间)',
'tqtActivity.applyEndTime.holder': '请输入(报名结束时间)',
'tqtActivity.applyEndTime.max': '(报名结束时间)最多null个字符',
'tqtActivity.applyEndTime.required': '(报名结束时间)必填',
'tqtActivity.searchApplyEndTime.holder': '搜索(报名结束时间)',
'tqtActivity.startTime.label': '(活动开始时间)',
'tqtActivity.startTime.holder': '请输入(活动开始时间)',
'tqtActivity.startTime.max': '(活动开始时间)最多null个字符',
'tqtActivity.startTime.required': '(活动开始时间)必填',
'tqtActivity.searchStartTime.holder': '搜索(活动开始时间)',
'tqtActivity.endTime.label': '(活动结束时间)',
'tqtActivity.endTime.holder': '请输入(活动结束时间)',
'tqtActivity.endTime.max': '(活动结束时间)最多null个字符',
'tqtActivity.endTime.required': '(活动结束时间)必填',
'tqtActivity.searchEndTime.holder': '搜索(活动结束时间)',
'tqtActivity.concat.label': '(联系人)',
'tqtActivity.concat.holder': '请输入(联系人)',
'tqtActivity.concat.max': '(联系人)最多10个字符',
'tqtActivity.concat.required': '(联系人)必填',
'tqtActivity.searchConcat.holder': '搜索(联系人)',
'tqtActivity.phone.label': '',
'tqtActivity.phone.holder': '请输入',
'tqtActivity.phone.max': '最多11个字符',
'tqtActivity.phone.required': '必填',
'tqtActivity.searchPhone.holder': '搜索',
'tqtActivity.details.label': '详情',
'tqtActivity.details.holder': '请输入详情',
'tqtActivity.details.max': '详情最多1,028个字符',
'tqtActivity.details.required': '详情必填',
'tqtActivity.searchDetails.holder': '搜索详情',
'tqtActivity.status.label': '(活动状态)0已取消，1进行中，2已结束',
'tqtActivity.status.holder': '请输入(活动状态)0已取消，1进行中，2已结束',
'tqtActivity.status.max': '(活动状态)0已取消，1进行中，2已结束最多1个字符',
'tqtActivity.status.required': '(活动状态)0已取消，1进行中，2已结束必填',
'tqtActivity.searchStatus.holder': '搜索(活动状态)0已取消，1进行中，2已结束',
'tqtActivity.content.label': '活动内容',
'tqtActivity.content.holder': '请输入活动内容',
'tqtActivity.content.max': '活动内容最多1,028个字符',
'tqtActivity.content.required': '活动内容必填',
'tqtActivity.searchContent.holder': '搜索活动内容',
'tqtActivity.signNum.label': '已报名人数',
'tqtActivity.signNum.holder': '请输入已报名人数',
'tqtActivity.signNum.max': '已报名人数最多11个字符',
'tqtActivity.signNum.required': '已报名人数必填',
'tqtActivity.searchSignNum.holder': '搜索已报名人数',
'tqtActivity.createTime.label': '',
'tqtActivity.createTime.holder': '请输入',
'tqtActivity.createTime.max': '最多null个字符',
'tqtActivity.createTime.required': '必填',
'tqtActivity.searchCreateTime.holder': '搜索',
'tqtActivity.maxNum.label': '最大报名人数',
'tqtActivity.maxNum.holder': '请输入最大报名人数',
'tqtActivity.maxNum.max': '最大报名人数最多11个字符',
'tqtActivity.maxNum.required': '最大报名人数必填',
'tqtActivity.searchMaxNum.holder': '搜索最大报名人数',
},
'zh-TW': {
'tqtActivity.id.label': '',
'tqtActivity.id.holder': '請輸入',
'tqtActivity.id.max': '最多11個字符',
'tqtActivity.id.required': '必填',
'tqtActivity.searchId.holder': '搜索',
'tqtActivity.adminId.label': '管理员id',
'tqtActivity.adminId.holder': '請輸入管理员id',
'tqtActivity.adminId.max': '管理员id最多11個字符',
'tqtActivity.adminId.required': '管理员id必填',
'tqtActivity.searchAdminId.holder': '搜索管理员id',
'tqtActivity.theme.label': '主题',
'tqtActivity.theme.holder': '請輸入主题',
'tqtActivity.theme.max': '主题最多58個字符',
'tqtActivity.theme.required': '主题必填',
'tqtActivity.searchTheme.holder': '搜索主题',
'tqtActivity.picPath.label': '图片路径',
'tqtActivity.picPath.holder': '請輸入图片路径',
'tqtActivity.picPath.max': '图片路径最多255個字符',
'tqtActivity.picPath.required': '图片路径必填',
'tqtActivity.searchPicPath.holder': '搜索图片路径',
'tqtActivity.address.label': '地点',
'tqtActivity.address.holder': '請輸入地点',
'tqtActivity.address.max': '地点最多58個字符',
'tqtActivity.address.required': '地点必填',
'tqtActivity.searchAddress.holder': '搜索地点',
'tqtActivity.organization.label': '组织机构',
'tqtActivity.organization.holder': '請輸入组织机构',
'tqtActivity.organization.max': '组织机构最多54個字符',
'tqtActivity.organization.required': '组织机构必填',
'tqtActivity.searchOrganization.holder': '搜索组织机构',
'tqtActivity.applyEndTime.label': '(报名结束时间)',
'tqtActivity.applyEndTime.holder': '請輸入(报名结束时间)',
'tqtActivity.applyEndTime.max': '(报名结束时间)最多null個字符',
'tqtActivity.applyEndTime.required': '(报名结束时间)必填',
'tqtActivity.searchApplyEndTime.holder': '搜索(报名结束时间)',
'tqtActivity.startTime.label': '(活动开始时间)',
'tqtActivity.startTime.holder': '請輸入(活动开始时间)',
'tqtActivity.startTime.max': '(活动开始时间)最多null個字符',
'tqtActivity.startTime.required': '(活动开始时间)必填',
'tqtActivity.searchStartTime.holder': '搜索(活动开始时间)',
'tqtActivity.endTime.label': '(活动结束时间)',
'tqtActivity.endTime.holder': '請輸入(活动结束时间)',
'tqtActivity.endTime.max': '(活动结束时间)最多null個字符',
'tqtActivity.endTime.required': '(活动结束时间)必填',
'tqtActivity.searchEndTime.holder': '搜索(活动结束时间)',
'tqtActivity.concat.label': '(联系人)',
'tqtActivity.concat.holder': '請輸入(联系人)',
'tqtActivity.concat.max': '(联系人)最多10個字符',
'tqtActivity.concat.required': '(联系人)必填',
'tqtActivity.searchConcat.holder': '搜索(联系人)',
'tqtActivity.phone.label': '',
'tqtActivity.phone.holder': '請輸入',
'tqtActivity.phone.max': '最多11個字符',
'tqtActivity.phone.required': '必填',
'tqtActivity.searchPhone.holder': '搜索',
'tqtActivity.details.label': '详情',
'tqtActivity.details.holder': '請輸入详情',
'tqtActivity.details.max': '详情最多1,028個字符',
'tqtActivity.details.required': '详情必填',
'tqtActivity.searchDetails.holder': '搜索详情',
'tqtActivity.status.label': '(活动状态)0已取消，1进行中，2已结束',
'tqtActivity.status.holder': '請輸入(活动状态)0已取消，1进行中，2已结束',
'tqtActivity.status.max': '(活动状态)0已取消，1进行中，2已结束最多1個字符',
'tqtActivity.status.required': '(活动状态)0已取消，1进行中，2已结束必填',
'tqtActivity.searchStatus.holder': '搜索(活动状态)0已取消，1进行中，2已结束',
'tqtActivity.content.label': '活动内容',
'tqtActivity.content.holder': '請輸入活动内容',
'tqtActivity.content.max': '活动内容最多1,028個字符',
'tqtActivity.content.required': '活动内容必填',
'tqtActivity.searchContent.holder': '搜索活动内容',
'tqtActivity.signNum.label': '已报名人数',
'tqtActivity.signNum.holder': '請輸入已报名人数',
'tqtActivity.signNum.max': '已报名人数最多11個字符',
'tqtActivity.signNum.required': '已报名人数必填',
'tqtActivity.searchSignNum.holder': '搜索已报名人数',
'tqtActivity.createTime.label': '',
'tqtActivity.createTime.holder': '請輸入',
'tqtActivity.createTime.max': '最多null個字符',
'tqtActivity.createTime.required': '必填',
'tqtActivity.searchCreateTime.holder': '搜索',
'tqtActivity.maxNum.label': '最大报名人数',
'tqtActivity.maxNum.holder': '請輸入最大报名人数',
'tqtActivity.maxNum.max': '最大报名人数最多11個字符',
'tqtActivity.maxNum.required': '最大报名人数必填',
'tqtActivity.searchMaxNum.holder': '搜索最大报名人数',
},
'en-US': {
'tqtActivity.id.label': '',
'tqtActivity.id.holder': 'Enter ',
'tqtActivity.id.max': ' max length: 11',
'tqtActivity.id.required': ' required',
'tqtActivity.searchId.holder': 'Search ',
'tqtActivity.adminId.label': '管理员id',
'tqtActivity.adminId.holder': 'Enter 管理员id',
'tqtActivity.adminId.max': '管理员id max length: 11',
'tqtActivity.adminId.required': '管理员id required',
'tqtActivity.searchAdminId.holder': 'Search 管理员id',
'tqtActivity.theme.label': '主题',
'tqtActivity.theme.holder': 'Enter 主题',
'tqtActivity.theme.max': '主题 max length: 58',
'tqtActivity.theme.required': '主题 required',
'tqtActivity.searchTheme.holder': 'Search 主题',
'tqtActivity.picPath.label': '图片路径',
'tqtActivity.picPath.holder': 'Enter 图片路径',
'tqtActivity.picPath.max': '图片路径 max length: 255',
'tqtActivity.picPath.required': '图片路径 required',
'tqtActivity.searchPicPath.holder': 'Search 图片路径',
'tqtActivity.address.label': '地点',
'tqtActivity.address.holder': 'Enter 地点',
'tqtActivity.address.max': '地点 max length: 58',
'tqtActivity.address.required': '地点 required',
'tqtActivity.searchAddress.holder': 'Search 地点',
'tqtActivity.organization.label': '组织机构',
'tqtActivity.organization.holder': 'Enter 组织机构',
'tqtActivity.organization.max': '组织机构 max length: 54',
'tqtActivity.organization.required': '组织机构 required',
'tqtActivity.searchOrganization.holder': 'Search 组织机构',
'tqtActivity.applyEndTime.label': '(报名结束时间)',
'tqtActivity.applyEndTime.holder': 'Enter (报名结束时间)',
'tqtActivity.applyEndTime.max': '(报名结束时间) max length: null',
'tqtActivity.applyEndTime.required': '(报名结束时间) required',
'tqtActivity.searchApplyEndTime.holder': 'Search (报名结束时间)',
'tqtActivity.startTime.label': '(活动开始时间)',
'tqtActivity.startTime.holder': 'Enter (活动开始时间)',
'tqtActivity.startTime.max': '(活动开始时间) max length: null',
'tqtActivity.startTime.required': '(活动开始时间) required',
'tqtActivity.searchStartTime.holder': 'Search (活动开始时间)',
'tqtActivity.endTime.label': '(活动结束时间)',
'tqtActivity.endTime.holder': 'Enter (活动结束时间)',
'tqtActivity.endTime.max': '(活动结束时间) max length: null',
'tqtActivity.endTime.required': '(活动结束时间) required',
'tqtActivity.searchEndTime.holder': 'Search (活动结束时间)',
'tqtActivity.concat.label': '(联系人)',
'tqtActivity.concat.holder': 'Enter (联系人)',
'tqtActivity.concat.max': '(联系人) max length: 10',
'tqtActivity.concat.required': '(联系人) required',
'tqtActivity.searchConcat.holder': 'Search (联系人)',
'tqtActivity.phone.label': '',
'tqtActivity.phone.holder': 'Enter ',
'tqtActivity.phone.max': ' max length: 11',
'tqtActivity.phone.required': ' required',
'tqtActivity.searchPhone.holder': 'Search ',
'tqtActivity.details.label': '详情',
'tqtActivity.details.holder': 'Enter 详情',
'tqtActivity.details.max': '详情 max length: 1,028',
'tqtActivity.details.required': '详情 required',
'tqtActivity.searchDetails.holder': 'Search 详情',
'tqtActivity.status.label': '(活动状态)0已取消，1进行中，2已结束',
'tqtActivity.status.holder': 'Enter (活动状态)0已取消，1进行中，2已结束',
'tqtActivity.status.max': '(活动状态)0已取消，1进行中，2已结束 max length: 1',
'tqtActivity.status.required': '(活动状态)0已取消，1进行中，2已结束 required',
'tqtActivity.searchStatus.holder': 'Search (活动状态)0已取消，1进行中，2已结束',
'tqtActivity.content.label': '活动内容',
'tqtActivity.content.holder': 'Enter 活动内容',
'tqtActivity.content.max': '活动内容 max length: 1,028',
'tqtActivity.content.required': '活动内容 required',
'tqtActivity.searchContent.holder': 'Search 活动内容',
'tqtActivity.signNum.label': '已报名人数',
'tqtActivity.signNum.holder': 'Enter 已报名人数',
'tqtActivity.signNum.max': '已报名人数 max length: 11',
'tqtActivity.signNum.required': '已报名人数 required',
'tqtActivity.searchSignNum.holder': 'Search 已报名人数',
'tqtActivity.createTime.label': '',
'tqtActivity.createTime.holder': 'Enter ',
'tqtActivity.createTime.max': ' max length: null',
'tqtActivity.createTime.required': ' required',
'tqtActivity.searchCreateTime.holder': 'Search ',
'tqtActivity.maxNum.label': '最大报名人数',
'tqtActivity.maxNum.holder': 'Enter 最大报名人数',
'tqtActivity.maxNum.max': '最大报名人数 max length: 11',
'tqtActivity.maxNum.required': '最大报名人数 required',
'tqtActivity.searchMaxNum.holder': 'Search 最大报名人数',
}
};